module.exports = __webpack_public_path__ + "static/media/sonicstop-2.d43fa7b7.jpg";